module.exports = __webpack_public_path__ + "img/09-shunya.1285cae1.png";